// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginScreeenNew_container__1GBvd","loginContainer":"LoginScreeenNew_loginContainer__2fgX9"};